import React, { useState } from 'react';

function Calcolatore() {
  const [distanza, setDistanza] = useState('');
  const [dislivello, setDislivello] = useState('');
  const [ore, setOre] = useState('');
  const [minuti, setMinuti] = useState('');
  const [secondi, setSecondi] = useState('');
  const [punteggio, setPunteggio] = useState(null);
  const [livello, setLivello] = useState('');

  const calcolaITRA = () => {
    const distanzaNum = parseFloat(distanza);
    const dislivelloNum = parseFloat(dislivello);
    const oreNum = parseInt(ore) || 0;
    const minutiNum = parseInt(minuti) || 0;
    const secondiNum = parseInt(secondi) || 0;

    const tempoMinuti = oreNum * 60 + minutiNum + secondiNum / 60;

    if (isNaN(distanzaNum) || isNaN(dislivelloNum) || tempoMinuti <= 0) {
      alert('Per favore, inserisci valori validi.');
      return;
    }

    const distanzaEffettiva = distanzaNum + (dislivelloNum / 100);
    const tempoOre = tempoMinuti / 60;
    const performance = distanzaEffettiva / tempoOre;

    const punteggioCalcolato = Math.round((performance / 15) * 100);
    setPunteggio(punteggioCalcolato);

    let livelloCorrente = '';
    if (punteggioCalcolato < 60) {
      livelloCorrente = 'Base';
    } else if (punteggioCalcolato < 80) {
      livelloCorrente = 'Intermedio';
    } else if (punteggioCalcolato < 100) {
      livelloCorrente = 'Avanzato';
    } else {
      livelloCorrente = 'Elite';
    }
    setLivello(livelloCorrente);
  };

  const resetForm = () => {
    setDistanza('');
    setDislivello('');
    setOre('');
    setMinuti('');
    setSecondi('');
    setPunteggio(null);
    setLivello('');
  };

  const suggerimentoLivello = {
    'Base': 'Ideale per trail brevi (fino a 30 km). Continua ad allenarti per migliorare!',
    'Intermedio': 'Ottima base! Puoi affrontare gare fino a 50 km con buon margine.',
    'Avanzato': 'Ottimo livello! Sei pronto per trail lunghi e tecnici.',
    'Elite': 'Livello eccellente. Sei tra i top runner!'
  };

  return (
    <div className="max-w-md mx-auto mt-10 p-6 bg-white shadow-md rounded-md">
      <h1 className="text-2xl font-bold mb-4 text-center">Simulatore Performance ITRA Personale</h1>

      <div className="mb-4">
        <label className="block text-sm font-medium text-gray-700">Distanza (km):</label>
        <input
          type="number"
          value={distanza}
          onChange={(e) => setDistanza(e.target.value)}
          className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
          placeholder="Es. 50"
        />
      </div>

      <div className="mb-4">
        <label className="block text-sm font-medium text-gray-700">Dislivello positivo (m):</label>
        <input
          type="number"
          value={dislivello}
          onChange={(e) => setDislivello(e.target.value)}
          className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
          placeholder="Es. 2000"
        />
      </div>

      <div className="mb-4">
        <label className="block text-sm font-medium text-gray-700">Tempo gara:</label>
        <div className="flex gap-2">
          <input
            type="number"
            value={ore}
            onChange={(e) => setOre(e.target.value)}
            className="w-1/3 p-2 border border-gray-300 rounded-md"
            placeholder="Ore"
          />
          <input
            type="number"
            value={minuti}
            onChange={(e) => setMinuti(e.target.value)}
            className="w-1/3 p-2 border border-gray-300 rounded-md"
            placeholder="Minuti"
          />
          <input
            type="number"
            value={secondi}
            onChange={(e) => setSecondi(e.target.value)}
            className="w-1/3 p-2 border border-gray-300 rounded-md"
            placeholder="Secondi"
          />
        </div>
      </div>

      <button
        onClick={calcolaITRA}
        className="mt-4 w-full bg-[#d84d2c] text-white py-2 rounded hover:bg-[#c54426]"
      >
        Calcola Performance
      </button>

      <button
        onClick={resetForm}
        className="mt-2 w-full bg-gray-500 text-white py-2 rounded hover:bg-gray-600"
      >
        Reset
      </button>

      {punteggio !== null && (
        <div className="mt-6 text-center">
          <p className="text-xl font-semibold">Performance ITRA stimata: {punteggio} punti</p>
          <p className="text-lg font-bold">Livello: {livello}</p>
          <p className="text-sm mt-2 text-gray-700">{suggerimentoLivello[livello]}</p>
        </div>
      )}

      <div className="mt-8 text-sm text-gray-700 leading-relaxed">
        <h2 className="text-md font-semibold mb-2">Cos’è la Performance ITRA Personale?</h2>
        <p>
          La performance ITRA personale è una stima del tuo livello atletico basata su distanza, dislivello e tempo gara.
          Non è un punteggio ufficiale, ma un indicatore utile per capire il tuo stato di forma rispetto agli standard del trail running.
        </p>
        <p className="mt-2">
          L'indice ITRA ufficiale viene calcolato su più gare certificate, ma questo simulatore ti dà un’idea immediata della tua preparazione.
        </p>
        <p className="mt-2 italic text-gray-600">
          Usa questo strumento per confrontare le tue prestazioni, scegliere gare adatte al tuo livello e monitorare i tuoi progressi nel tempo.
        </p>
      </div>

      <p className="text-xs text-gray-500 mt-6 text-center">
        Questo strumento è fornito a scopo puramente informativo e non è affiliato né approvato ufficialmente da ITRA (International Trail Running Association). I punteggi stimati non hanno valore ufficiale e non garantiscono l’ammissione a gare o eventi.
        <br /><br />
        Il tool è stato sviluppato dal team di <a href="https://ultratrail.it/" className="text-[#d84d2c] underline" target="_blank" rel="noopener noreferrer">UltraTrail.it</a>, un progetto indipendente nato per supportare trail runner e appassionati con risorse utili, guide e strumenti pratici.
      </p>
    </div>
  );
}

export default Calcolatore;
